import React, { useEffect } from "react";
import "../styles/contact.css";
import uasImage from "../assets/UAS.JPG";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-main-page">
      {/* ================= HERO ================= */}
      <section className="contact-hero">
        <div className="container">
          <h1>Contact Us</h1>
        </div>
      </section>

      {/* ================= CONTACT GRID ================= */}
      <section className="contact-info-section">
        <div className="container">
          <div className="contact-grid">
            
            {/* EMAIL */}
            <div className="contact-card">
              <div className="icon">📧</div>
              <h3>Email</h3>
              <p className="highlight">contact@uastf.co.in</p>
              <p className="muted">Official support & enquiries</p>
            </div>

            {/* PHONE */}
            <div className="contact-card">
              <div className="icon">📞</div>
              <h3>Phone</h3>
              <p className="highlight">+91 81150 00838</p>
              {/* <p className="highlight">+91 87569 98280</p> */}
              <p className="muted">Office: 9:30 AM – 6:00 PM</p>
            </div>

            {/* SITE ADDRESS - Image side-by-side with minimal padding */}
            <div className="contact-card wide site-card-flex">
              <div className="site-image-box">
                <img src={uasImage} alt="UAS Board" />
              </div>
              <div className="site-info-box">
                <div className="icon">📍</div>
                <h3>Site Address</h3>
                <p>
                  <strong>UAS Testing Foundation</strong><br />
                  Hall TP G1 & TP G2, <strong>Technopark@IITK Building</strong><br />
                  IIT Kanpur Research & Technology Park Foundation<br />
                  Kalyanpur, Kanpur – 208016, UP, India
                </p>
              </div>
            </div>

            {/* REGISTERED OFFICE */}
            <div className="contact-card wide">
              <div className="icon">🏢</div>
              <h3>Registered Office</h3>
              <p>
                <strong>UAS Testing Foundation</strong><br />
                Transport Aircraft Division, HAL, Post Box No. 225,<br />
                Chakeri, Kanpur – 208008, UP
              </p>
            </div>
          </div>

          {/* ================= MAP SECTION ================= */}
          <div className="map-wrapper">
            <div className="map-header">
              <h4>Find us on Campus</h4>
              <p>Technopark@IITK, Indian Institute of Technology Kanpur</p>
            </div>
            <iframe
              title="Technopark IIT Kanpur Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3570.5284144413!2d80.2291!3d26.51!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399c370198000001%3A0x7d6b38c3e803a6e6!2sTechnopark%40IITK!5e0!3m2!1sen!2sin!4v1700000000000"
              width="100%"
              height="350"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>

      {/* ================= NOTE ================= */}
      <section className="contact-note-section">
        <div className="container">
          <p className="security-notice">
            <strong>Security Notice:</strong> Technopark@IITK is a restricted area. 
            Prior appointment and valid ID are mandatory for all visitors.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Contact;